import { msg } from '@lingui/core/macro';
import { PlayerPosition } from 'modules/teams/domain/enums/player-position';
import type { MessageDescriptor } from 'shared/i18n';

/** Подписи амплуа — строчными, как было в `player.position.*`: заглавную букву ставят по месту. */
export const PLAYER_POSITION_LABELS: Record<PlayerPosition, MessageDescriptor> = {
  [PlayerPosition.DEFENDER]: msg`защитник`,
  [PlayerPosition.FORWARD]: msg`нападающий`,
  [PlayerPosition.GOALKEEPER]: msg`вратарь`,
  [PlayerPosition.MIDFIELDER]: msg`полузащитник`,
};

/**
 * Амплуа приходит в двух регистрах: у игрока из состава — строчными, у заявки — заглавными из
 * GraphQL. Неизвестное значение — `undefined`, подпись по месту берёт исходную строку.
 */
export function getPlayerPositionLabel(position?: string | null): MessageDescriptor | undefined {
  return position ? PLAYER_POSITION_LABELS[position.toLowerCase() as PlayerPosition] : undefined;
}
